/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import {
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  FormControl,
  InputAdornment,
  InputLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  OutlinedInput,
  Skeleton,
  Snackbar,
} from '@mui/material';
import { Avatar } from 'stream-chat-react';
import moment from 'moment';
import {
  Add,
  CheckCircle,
  DateRange,
  Search,
} from '@mui/icons-material';
import HorseIcon from '../../../../../../components/CustomIcons/Horse';
import Horse from '../../../../../../components/Horse';
import AddEditLocationModalComponent from '../AddEditLocationModal';
import BarnService from '../../../../../../services/BarnService';
import AddEditModal from '../../../../../horse/Horse/components/LocationsCard/components/AddEditModal';
import { getLocationHorses } from '../../../../../../redux/location/actions';

const HorsesCardComponent = ({
  location,
  onlyButton,
  onHorsesAdded,
  variant,
  icon,
}) => {
  const dispatch = useDispatch();

  // React state
  const [snackbar, setSnackbar] = React.useState(null);
  const [loadingHorses, setLoadingHorses] = React.useState(true);
  const [selectedBarnHorses, setSelectedBarnHorses] = React.useState([]);
  const [barnHorses, setBarnHorses] = React.useState([]);
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const [openAddEditHorseLocationModal, setOpenAddEditHorseLocationModal] = React.useState(null);
  const [selectedHorseLocation, setSelectedHorseLocation] = React.useState(null);
  const [search, setSearch] = React.useState('');
  const [openAddHorsesToLocationModal, setOpenAddHorsesToLocationModal] = React.useState(false);
  const openMenu = Boolean(menuAnchorEl);

  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  const allBarnHorses = useSelector((state) => state.barn.allBarnHorses);
  const isFetchingLocationHorses = useSelector((state) => state.location.isFetchingLocationHorses);
  const locationHorses = useSelector((state) => state.location.locationHorses);

  const refreshData = () => {
    dispatch(getLocationHorses(location.id, 0, 150, '', new Date()));
    setLoadingHorses(true);
    // Get Barn Horses at this location in this time range
    BarnService.getBarnHorses(selectedBarn.id, 0, 150, '', '', moment().startOf('day').toDate().toISOString(), moment().endOf('day').toDate().toISOString(), location.id).then((data) => {
      setBarnHorses(data.content);
      setLoadingHorses(false);
      // get Feeds
    }).catch((error) => {
      console.error(error);
      setSnackbar({
        children: 'There was an error getting horses at this location for this date',
        severity: 'error',
      });
      setBarnHorses([]);
      setLoadingHorses(false);
    });
  }

  React.useEffect(() => {
    if (location && location.pingumTagId) {
      refreshData();
      setSearch('')
    }
  }, [location]);

  const handleClickMenu = (event) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedBarnHorses([]);
    setSearch('')
  };
  const handleCloseMenu = (reload) => {
    setMenuAnchorEl(null);
    setSelectedBarnHorses([]);
    setOpenAddEditHorseLocationModal(false);
    if (reload) {
      refreshData()
    }
  };

  const getButton = () => (
    <Box>
      <Button size="small" variant={variant} startIcon={icon && <Add />} onClick={handleClickMenu}>Add Horses to {location.name}</Button>
      <Menu
        id="add-feed-menu"
        MenuListProps={{ 'aria-labelledby': 'add-feed-button' }}
        anchorEl={menuAnchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'right',
            gap: 2,
            p: 2,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Button disabled={selectedBarnHorses.length === 0} size="small" startIcon={<CheckCircle />} variant="outlined" onClick={() => { setOpenAddHorsesToLocationModal(true) }}>Confirm and Add</Button>

          <Divider />
          <FormControl
            margin="none"
            variant="outlined"
            fullWidth
            size="small"
          >
            <InputLabel htmlFor="outlined-adornment-search">Search</InputLabel>
            <OutlinedInput
              id="outlined-adornment-search"
              value={search}
              autoFocus
              onChange={(e) => setSearch(e.target.value)}
              endAdornment={
                <InputAdornment position="end"><Search /></InputAdornment>
              }
              label="Search"
            />
          </FormControl>
        </Box>
        {
          allBarnHorses.filter((bh) => barnHorses
            .map((filterBh) => filterBh.horse.id).indexOf(bh.horse.id) < 0 && (`${bh.horse.name}${bh.horse.showName || ''}`).toLowerCase().includes(search.toLowerCase()))
            .sort((a, b) => -b.horse.name.localeCompare(a.horse.name)).map((bh) => (
              <MenuItem
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
                disableRipple
                key={`barnhorse-feed-item-${bh.id}`}
                onClick={() => {
                  const isChecked = !!selectedBarnHorses.find((b) => b.id === bh.id)
                  if (!isChecked) {
                    setSelectedBarnHorses([...selectedBarnHorses, bh.horse.id])
                  } else {
                    setSelectedBarnHorses(selectedBarnHorses.filter((id) => id !== bh.horse.id))
                  }
                }}
              >
                <Horse size={25} horse={bh.horse} />
                <Checkbox
                  checked={selectedBarnHorses.indexOf(bh.horse.id) >= 0}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedBarnHorses([...selectedBarnHorses, bh.horse.id])
                    } else {
                      setSelectedBarnHorses(selectedBarnHorses.filter((id) => id !== bh.horse.id))
                    }
                  }}
                />
              </MenuItem>
            ))
        }
      </Menu>
      <AddEditModal
        open={!!selectedHorseLocation || openAddHorsesToLocationModal}
        horseIds={selectedHorseLocation
          ? undefined
          : selectedBarnHorses}
        horseId={selectedHorseLocation && selectedHorseLocation.horse.id}
        horseLocation={selectedHorseLocation}
        currentHorseLocation={selectedHorseLocation}
        onClose={() => {
          refreshData(); handleCloseMenu()
          setOpenAddHorsesToLocationModal(false); setSelectedHorseLocation(null);
          onHorsesAdded();
        }}
        location={location}
      />
    </Box>
  )

  if (onlyButton) {
    return getButton()
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={9} md={8}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Typography variant="h6" gutterBottom={false}>Horses Currently at <b>{location.name}</b></Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardHeader
            avatar={<Avatar><HorseIcon /></Avatar>}
            action={getButton()}
            title={`Horses @ ${location.name}`}
            subheader={`On Date ${moment().format('ll')}`}
          />
          <CardContent>
            <List
              aria-label="horse feed"
            >
              {
                (loadingHorses || isFetchingLocationHorses) && (
                  <>
                    <ListItem dense divider><Skeleton height={60} width="100%" sx={{ borderRadius: 2 }} /></ListItem>
                    <ListItem dense divider><Skeleton height={60} width="100%" sx={{ borderRadius: 2 }} /></ListItem>
                    <ListItem dense divider><Skeleton height={60} width="100%" sx={{ borderRadius: 2 }} /></ListItem>
                    <ListItem dense divider><Skeleton height={60} width="100%" sx={{ borderRadius: 2 }} /></ListItem>
                    <ListItem dense divider><Skeleton height={60} width="100%" sx={{ borderRadius: 2 }} /></ListItem>
                  </>
                )
              }
              {
                (!loadingHorses && !isFetchingLocationHorses && barnHorses.length === 0)
                && (
                  <ListItemButton disabled><ListItemText primary="No horses are currently at this location" /></ListItemButton>
                )
              }
              {(!loadingHorses && !isFetchingLocationHorses)
                && (locationHorses.content.filter((lh) => barnHorses.find((bh) => bh.horse.id === lh.horse.id))
                  .sort((a, b) => -b.horse.name.localeCompare(a.horse.name)).map((locationHorse) => (
                    <ListItemButton
                      key={locationHorse.id}
                      divider
                      onClick={() => setSelectedHorseLocation(locationHorse)}
                    >
                      <Grid container spacing="2">
                        <Grid item xs={6} sx={{ mb: 1 }}>
                          <Horse horse={locationHorse.horse} size={40} />
                        </Grid>
                        <Grid item xs={6}>
                          <ListItem dense>
                            <ListItemIcon><DateRange /></ListItemIcon>
                            <ListItemText
                              primary={`Starting Date: ${moment(locationHorse.startDate).format('ll')}`}
                              secondary={locationHorse.endDate
                                ? `Scheduled End: ${moment(locationHorse.endDate).format('ll')}`
                                : 'No Scheduled End Date'}
                            />
                          </ListItem>
                        </Grid>
                      </Grid>
                    </ListItemButton>
                  )))}
            </List>
          </CardContent>
        </Card>
        {!!snackbar && (
          <Snackbar open onClose={() => { setSnackbar(null); }} autoHideDuration={6000}>
            <Alert {...snackbar} onClose={() => { setSnackbar(null); }} />
          </Snackbar>
        )}
        <AddEditLocationModalComponent
          open={!!openAddEditHorseLocationModal}
          horseIds={selectedBarnHorses}
          onClose={handleCloseMenu}
          startDate={new Date()}
          endDate={null}
          location={location}
        />
      </Grid>
    </Grid>
  )
}

HorsesCardComponent.propTypes = {
  location: PropTypes.object.isRequired,
  onlyButton: PropTypes.bool,
  onHorsesAdded: PropTypes.func,
  variant: PropTypes.string,
  icon: PropTypes.bool,
};
HorsesCardComponent.defaultProps = {
  onlyButton: false,
  onHorsesAdded: () => { },
  variant: 'contained',
  icon: false,
}
export default HorsesCardComponent;
